import React, { useState } from 'react';
import { useLang } from '../i18n/LangContext';   // V147

// 재사용 가능한 수량 입력 컴포넌트
// +/- 버튼 + 숫자 클릭시 직접 입력
function QtyInput({ value, onChange, min = 0, size = 'md' }) {
  const { lang } = useLang();
  const [editing, setEditing] = useState(false);
  const [tempVal, setTempVal] = useState('');

  const btnSize = size === 'sm' ? '24px' : '28px';
  const fontSize = size === 'sm' ? '13px' : '16px';
  const numWidth = size === 'sm' ? '32px' : '40px';

  const commit = (raw) => {
    const n = parseInt(raw, 10);
    onChange(isNaN(n) ? min : Math.max(min, n));
    setEditing(false);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <button
        onClick={() => onChange(Math.max(min, value - 1))}
        style={{
          width: btnSize, height: btnSize, borderRadius: '6px',
          border: '1px solid #d1d5db', background: '#fff',
          cursor: 'pointer', fontSize: fontSize, lineHeight: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>−</button>

      {editing ? (
        <input
          autoFocus
          value={tempVal}
          onChange={e => setTempVal(e.target.value)}
          onBlur={() => commit(tempVal)}
          onKeyDown={e => { if (e.key === 'Enter') commit(tempVal); if (e.key === 'Escape') setEditing(false); }}
          style={{
            width: numWidth, height: btnSize, textAlign: 'center',
            border: '1.5px solid #FF6F0F', borderRadius: '6px',
            fontSize: fontSize, fontWeight: '700', outline: 'none',
          }}
        />
      ) : (
        <span
          onClick={() => { setTempVal(String(value)); setEditing(true); }}
          title={lang === 'zh' ? '点击直接输入' : '클릭하면 직접 입력'}
          style={{
            minWidth: numWidth, height: btnSize,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: fontSize, fontWeight: '800', color: '#18181B',
            cursor: 'text', borderRadius: '6px',
            border: '1px dashed transparent',
          }}
          onMouseEnter={e => e.currentTarget.style.borderColor = '#FF6F0F'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'transparent'}
        >{value}</span>
      )}

      <button
        onClick={() => onChange(value + 1)}
        style={{
          width: btnSize, height: btnSize, borderRadius: '6px',
          border: '1px solid #d1d5db', background: '#fff',
          cursor: 'pointer', fontSize: fontSize, lineHeight: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>+</button>
    </div>
  );
}

export default QtyInput;
